module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-modal",
    class: {
      error: _vm.isError
    },
    attrs: {
      "id": "visibilitat-modal"
    }
  }, [_c('div', {
    staticClass: "dismiss",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.$t('title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.mapa.nomAplicacio))]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.canviarVisibilitatMapa
    }
  }, [_vm._v(_vm._s(_vm.$t('Canviar visibilitat')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a7785fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/perfil/components/visibilitat-modal/visibilitat-modal.vue
// module id = 297
// module chunks = 0